

































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { RouteConfig } from 'vue-router'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import vClickOutside from 'v-click-outside'
import { AxiosPromise, AxiosResponse } from 'axios'
import UserAvatar from '@/components/User/UserAvatar.vue'
import PaidBadge from '@/components/PaidLabel/PaidBadge.vue'
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue'
import CustomSelectCreateLink from '@/components/CustomSelect/CustomSelectCreateLink.vue'
import SidebarCloseButton from '@/components/Sidebar/SidebarCloseButton.vue'
import { AUTH__LOGOUT, SCRIPTS__FETCH } from '@/store/actions'
import { UserActionTypes } from '@/store/modules/users/actions'
import { CompanyActionTypes } from '@/store/modules/companies'
import { KnowledgeAction } from '@/store/modules/knowledge/actions'
import { Company } from '@/models/companies'
import { ScriptUnit } from '@/models/scripts'
import { CompanyUser, UserFull, UserScope } from '@/models/users'
import { RouteNames } from '@/router'

interface Data {
  toUserSettings: Partial<RouteConfig>
  toCompanySettings: Partial<RouteConfig>
  toCompanyCreate: Partial<RouteConfig>
}

interface Methods {
  [AUTH__LOGOUT]: () => AxiosPromise<boolean>
  [CompanyActionTypes.Activate]: (id: string) => Promise<AxiosResponse<boolean>>
  [SCRIPTS__FETCH]: () => Promise<AxiosResponse<ScriptUnit[]>>
  [UserActionTypes.FetchCompanyUsers]: () => Promise<
    AxiosResponse<CompanyUser[]>
  >
  logout: () => void
  switchCompany: (_id: string) => Promise<void>
  handleClickRouteLink: () => void
  handleOpenCarrotQuestChat: () => void
}

interface Computed {
  getMe: UserFull
  getCompanyIsPro: boolean
  getCompaniesList: Company[]
  canDoScope: (scope: UserScope) => boolean
  activeCompany: Company | undefined
  canShowCompanySettings: boolean
  nonActiveCompanies: Company[]
  fullname: string
  fi: string
}

interface Props {
  isMobile: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    PaidBadge,
    UserAvatar,
    CustomSelect,
    CustomSelectCreateLink,
    SidebarCloseButton,
  },
  props: {
    isMobile: {
      required: true,
    },
  },
  data() {
    return {
      toUserSettings: {
        name: RouteNames.UserSettings,
      },
      toCompanySettings: {
        name: RouteNames.CompanySettings,
      },
      toCompanyCreate: {
        name: RouteNames.CompanyCreate,
      },
    }
  },
  computed: {
    ...mapGetters([
      'getMe',
      'getCompanyIsPro',
      'getCompaniesList',
      'canDoScope',
    ]),
    activeCompany: {
      get() {
        return this.$store.getters.getActiveCompany
      },
      set(company) {
        if (company) {
          this.switchCompany(String(company.id))
        }
      },
    },
    canShowCompanySettings(): boolean {
      return (
        this.canDoScope(UserScope.Users) && this.canDoScope(UserScope.Roles)
      )
    },
    nonActiveCompanies(): Company[] {
      return this.getCompaniesList.filter(
        (one: Company) => one.id !== this.activeCompany?.id,
      )
    },
    fullname(): string {
      return `${this.getMe.contacts?.fname} ${this.getMe.contacts?.lname}`
    },
    fi(): string {
      return `${this.getMe.contacts?.fname[0]}${this.getMe.contacts?.lname[0]}`
    },
  },
  methods: {
    ...mapActions([
      AUTH__LOGOUT,
      CompanyActionTypes.Activate,
      KnowledgeAction.GetBases,
      SCRIPTS__FETCH,
      UserActionTypes.FetchCompanyUsers,
    ]),
    logout(): void {
      this[AUTH__LOGOUT]()
    },
    async switchCompany(_id: string): Promise<void> {
      await this[CompanyActionTypes.Activate](_id)

      this.$router.push({ name: RouteNames.BackwardReloader })

      this.$store.dispatch(KnowledgeAction.SetSelectedBaseId, '')
      this.$store.dispatch(KnowledgeAction.GetBases)
      this.$store.dispatch(ADD_TOAST_MESSAGE, {
        text: 'Изменена активная компания',
        type: 'info',
      })
    },
    handleClickRouteLink() {
      this.$emit('route-link-click')
    },
    handleOpenCarrotQuestChat() {
      window.carrotquest?.open()
    },
  },
})
